<template>
  <div class="dashboard" >
      <v-layout wrap row justify-start class="ma-5">
        <v-flex xs6 px-2 mb-2 PRICING class="noPOPrint">
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Pricing History
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t3 = !t3">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t3">
              <v-layout row wrap class="text-xs-left" align-center>
                <v-flex xs4 px-1>
                  <v-autocomplete
                    :items="vendors"
                    solo :loading="loading"
                    item-text="name"
                    return-object
                    hide-details
                    v-model="pricing.v"
                    label="Select A Vendor"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 px-1>
                  <v-autocomplete
                    name="SKU"
                    label="SKU"
                    solo :loading="loading"
                    :items="products"
                    item-text="sku"
                    hide-details
                    :filter="filterObject"
                    v-model.trim="pricing.sku"
                  >
                    <template
                          slot="item"
                          slot-scope="{ item }"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary">amp_stories</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.item_name"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.name_ar"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-html="item.sku"></v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar v-if="item.img">
                          <img :src="item.img">
                        </v-list-tile-avatar>
                      </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs4 px-1>
                  <v-text-field
                    name="Price"
                    label="Price"
                    solo :loading="loading"
                    @keypress="isNumber($event)"
                    hide-details
                    v-model.trim="pricing.price"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t3">
              <v-spacer></v-spacer>
              <v-btn color="success" :loading="loading" :disabled="Object.values(pricing).length < 3" @click="savePricing()">Save Pricing</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2 mb-2 VENDORS class="noPOPrint">
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Vendors
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t5 = !t5">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t5">
              <v-layout row wrap class="text-xs-left">
                <v-flex xs12>
                  <v-select
                    :items="vendors"
                    solo :loading="loading"
                    item-text="name"
                    return-object
                    v-model="vendor"
                    label="Select A Vendor"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    name="Countries"
                    label="Countries"
                    solo :loading="loading"
                    item-text="name"
                    :items="countries"
                    v-model.trim="vendor.country"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    name="Currency"
                    label="Currency"
                    solo :loading="loading"
                    item-text="currency"
                    :items="currencies"
                    v-model.trim="vendor.currency"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="Name"
                    label="Name"
                    solo :loading="loading"
                    v-model.trim ="vendor.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="Address"
                    label="Address"
                    solo :loading="loading"
                    v-model.trim ="vendor.address"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="Phone"
                    label="Phone"
                    solo :loading="loading"
                    v-model.trim ="vendor.phone"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t5">
              <v-spacer></v-spacer>
              <v-btn color="success" :loading="loading" v-if="!vendor.key" @click="newVendors()">Save Vendor</v-btn>
              <v-btn color="success" :loading="loading" v-if="vendor.key" @click="updateVendors()">update Vendor</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2 mb-2 MOVING class="noPOPrint" v-if="false">
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Move Items
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t6 = !t6">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t6">
              <v-layout row wrap class="text-xs-left" align-center>
                <v-flex xs6 px-1 py-1>
                  <v-autocomplete
                    name="Source Warehouse"
                    label="Source Warehouse"
                    solo :loading="loading"
                    :readonly="lock"
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    hide-details
                    item-text="name"
                    :items="warehouses"
                    v-model.trim="mv.fwh"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-autocomplete
                    name="Destination Warehouse"
                    label="Destination Warehouse"
                    solo :loading="loading"
                    :readonly="lock"
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    hide-details
                    item-text="name"
                    :items="warehouses"
                    v-model.trim="mv.twh"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-select
                    :items="shippers"
                    hide-details
                    solo :loading="loading"
                    :readonly="!completeLock"
                    :class="`${!completeLock? 'tokenField' : ''}`"
                    :color="`${!completeLock? 'white' : ''}`"
                    :background-color="`${!completeLock? 'primary' : ''}`"
                    v-model="mv.ship_by"
                    append-outer-icon="add"
                    @click:append-outer="addshipdialog = true"
                    label="Select A Ship By"
                  ></v-select>
                  <v-layout row wrap>
                    <v-dialog v-model="addshipdialog" persistent max-width="290">
                      <v-card>
                        <v-card-title class="headline">You want to add a new Ship By?</v-card-title>
                        <v-card-text>
                          <v-text-field
                            label="Ship By"
                            required
                            v-model.trim="new_ship_by"
                          ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" flat @click="addshipdialog = false">Cancel</v-btn>
                          <v-btn color="green darken-1" flat @click="addShipBy()">add</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="text-xs-left">
                <v-flex xs12>
                  <v-layout row wrap align-center class="text-xs-left align-center elevation-2 pa-2">
                    <v-flex xs12 class="text-xs-center" style="font-size:16px;font-weight:bold;">
                      Move Items
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs6 style="font-size:11px;font-weight:bold;">
                          SKU
                        </v-flex>
                        <v-flex xs5 style="font-size:11px;font-weight:bold;">
                          Quantity
                        </v-flex>
                        
                        <v-flex xs1 px-1>
                          
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-for="(item, it) in mv.items" py-1 :key="'item-'+it">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs6>
                          <v-autocomplete
                            name="SKU"
                            label="SKU"
                            solo :loading="loading"
                            :readonly="completeLock"
                            :class="`${completeLock? 'tokenField' : ''}`"
                            :color="`${completeLock? 'white' : ''}`"
                            :background-color="`${completeLock? 'primary' : ''}`"
                            :items="products"
                            item-text="sku"
                            hide-details
                            v-model.trim="item.sku"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs5 px-1>
                          <v-text-field
                            name="Quantity"
                            label="Quantity"
                            solo :loading="loading"
                            :readonly="completeLock"
                            :class="`${completeLock? 'tokenField' : ''}`"
                            :color="`${completeLock? 'white' : ''}`"
                            :background-color="`${completeLock? 'primary' : ''}`"
                            @keypress="isNumber($event)"
                            hide-details
                            v-model.trim="item.quantity"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1>
                          <v-btn color="error" flat icon  :disabled="completeLock"
                            @click="()=>{
                              mv.items.splice(it, 1)
                            }"
                            small>
                            <v-icon small>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="primary" :disabled="completeLock" @click="()=>{
                          mv.items.push({
                            sku:'',
                            quantity:''
                          })
                        }">add item</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t6">
              <v-spacer></v-spacer>
              <v-btn color="success" :loading="loading" :disabled="Object.values(mv).length < 3" @click="mvOrderOut()">Move out</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2 mb-2 Hurt class="noPOPrint" v-if="false">
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Hurt Items
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t7 = !t7">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t7">
              <v-layout row wrap class="text-xs-left" align-center>
                <v-flex xs12 px-1 py-1>
                  <v-select
                    name="Action"
                    label="Action"
                    solo :loading="loading"
                    :readonly="lock"
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    hide-details
                    item-value="value"
                    :items="[
                      {text:'Move To Hurt', value:true},
                      {text:'Restore From Hurt', value:false}
                    ]"
                    v-model.trim="hurt.method"
                  ></v-select>
                </v-flex>
                <v-flex xs12 px-1 py-1>
                  <v-autocomplete
                    name="Warehouse"
                    label="Warehouse"
                    solo :loading="loading"
                    :readonly="lock"
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    hide-details
                    item-text="name"
                    :items="warehouses"
                    v-model.trim="hurt.wh"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="text-xs-left">
                <v-flex xs12>
                  <v-layout row wrap align-center class="text-xs-left align-center elevation-2 pa-2">
                    <v-flex xs12 class="text-xs-center" style="font-size:16px;font-weight:bold;">
                      Hurt Items
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs6 style="font-size:11px;font-weight:bold;">
                          SKU
                        </v-flex>
                        <v-flex xs5 style="font-size:11px;font-weight:bold;">
                          Quantity
                        </v-flex>
                        
                        <v-flex xs1 px-1>
                          
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-for="(item, it) in hurt.items" py-1 :key="'item-'+it">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs6>
                          <v-autocomplete
                            name="SKU"
                            label="SKU"
                            solo :loading="loading"
                            :readonly="completeLock"
                            :class="`${completeLock? 'tokenField' : ''}`"
                            :color="`${completeLock? 'white' : ''}`"
                            :background-color="`${completeLock? 'primary' : ''}`"
                            :items="products"
                            item-text="sku"
                            hide-details
                            v-model.trim="item.sku"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs5 px-1>
                          <v-text-field
                            name="Quantity"
                            label="Quantity"
                            solo :loading="loading"
                            :readonly="completeLock"
                            :class="`${completeLock? 'tokenField' : ''}`"
                            :color="`${completeLock? 'white' : ''}`"
                            :background-color="`${completeLock? 'primary' : ''}`"
                            @keypress="isNumber($event)"
                            hide-details
                            v-model.trim="item.quantity"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1>
                          <v-btn color="error" flat icon  :disabled="completeLock"
                            @click="()=>{
                              hurt.items.splice(it, 1)
                            }"
                            small>
                            <v-icon small>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="primary" :disabled="completeLock" @click="()=>{
                          hurt.items.push({
                            sku:'',
                            quantity:''
                          })
                        }">add item</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t7">
              <v-spacer></v-spacer>
              <v-btn color="success" v-if="hurt.method" :loading="loading" :disabled="Object.values(hurt).length < 3" @click="hurtOrder()">Move To Hurt</v-btn>
              <v-btn color="success" v-if="!hurt.method" :loading="loading" :disabled="Object.values(hurt).length < 3" @click="unhurtOrder()">Restore From Hurt</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 px-2 mb-2 PURCHASE class="noPOPrint">
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Purchase Orders
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t4 = !t4">toggle
              </v-btn>
						</v-card-title>
            <v-card-text v-if="t4">
              <v-layout row wrap class="text-xs-left">
                <v-flex xs4 px-1 py-1>
                </v-flex>
                <v-flex xs4 px-1 py-1>
                  <canvas id="barcode"></canvas>
                </v-flex>
                <v-flex xs4 px-1 py-1>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="text-xs-left noPOPrint">
                <!--  -->
                
                <v-flex xs6 px-1 py-1>
                  <v-text-field
                    solo :loading="loading"
                    readonly
                    solo-inverted
                    suffix="Key"
                    class="tokenField"
                    color="white"
                    background-color="primary"
                    hide-details
                    v-model="po.key"
                    label="Key"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-text-field
                    solo :loading="loading"
                    :readonly="lock"
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    hide-details
                    v-model="po.asn"
                    label="ASN"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-text-field
                    solo :loading="loading"
                    readonly
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    hide-details
                    v-model="po.number"
                    label="Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-autocomplete
                    name="Destination Warehouse"
                    label="Destination Warehouse"
                    solo :loading="loading"
                    :readonly="lock"
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    hide-details
                    item-text="name"
                    :items="warehouses"
                    v-model.trim="po.wh"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-autocomplete
                    :items="vendors"
                    solo :loading="loading"
                    item-text="name"
                    hide-details
                    :readonly="lock"
                    :class="`${lock? 'tokenField' : ''}`"
                    :color="`${lock? 'white' : ''}`"
                    :background-color="`${lock? 'primary' : ''}`"
                    return-object
                    @change="setVendor()"
                    v-model="po.v"
                    label="Select A Vendor"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-select
                    :items="['Pending', 'Purchase', 'Received', 'Partially Received']
                      .filter(x=>{
                        if(lock){
                          if(x != 'Pending' && x != 'Purchase'){
                            return x
                          } 
                        } else {
                          return x
                        }
                      })"
                    hide-details
                    solo :loading="loading"
                    :readonly="completeLock"
                    :class="`${completeLock? 'tokenField' : ''}`"
                    :color="`${completeLock? 'white' : ''}`"
                    :background-color="`${completeLock? 'primary' : ''}`"
                    @change="setItems()"
                    v-model="po.status"
                    label="Select A Status"
                  ></v-select>
                </v-flex>
                <v-flex xs6 px-1 py-1 v-if="!lock">
                  <v-menu
                    v-model="cDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="po.create_date"
                        :class="`${lock? 'tokenField' : ''}`"
                        :color="`${lock? 'white' : ''}`"
                        :background-color="`${lock? 'primary' : ''}`"
                        label="Create Date"
                        append-icon="event"
                        readonly
                        solo :loading="loading"
                        clearable
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="po.create_date" @input="cDate = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-menu
                    v-model="eDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="po.expected_date"
                        label="Expected Date"
                        append-icon="event"
                        readonly
                        solo :loading="loading"
                        clearable
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="po.expected_date" @input="eDate = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-menu
                    v-model="iDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="po.invoice_date"
                        label="Invoice Date"
                        append-icon="event"
                        readonly
                        solo :loading="loading"
                        clearable
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker  @change="updatePO()" v-model="po.invoice_date" @input="iDate = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-select
                    :items="invoicers"
                    hide-details
                    solo :loading="loading"
                    v-model="po.invoice_by"
                    @change="updatePO()"
                    append-outer-icon="add"
                    @click:append-outer="addinvoicedialog = true"
                    label="Select A Invoice By"
                  ></v-select>
                  <v-layout row wrap>
                    <v-dialog v-model="addinvoicedialog" persistent max-width="290">
                      <v-card>
                        <v-card-title class="headline">You want to add a new Invoice By?</v-card-title>
                        <v-card-text>
                          <v-text-field
                            label="Invoice By"
                            required
                            v-model.trim="new_invoice_by"
                          ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" flat @click="addinvoicedialog = false">Cancel</v-btn>
                          <v-btn color="green darken-1" flat @click="addInvoiceBy()">add</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-select
                    :items="shippers"
                    hide-details
                    solo :loading="loading"
                    v-model="po.ship_by"
                    @change="updatePO()"
                    append-outer-icon="add"
                    @click:append-outer="addshipdialog = true"
                    label="Select A Ship By"
                  ></v-select>
                  <v-layout row wrap>
                    <v-dialog v-model="addshipdialog" persistent max-width="290">
                      <v-card>
                        <v-card-title class="headline">You want to add a new Ship By?</v-card-title>
                        <v-card-text>
                          <v-text-field
                            label="Ship By"
                            required
                            v-model.trim="new_ship_by"
                          ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" flat @click="addshipdialog = false">Cancel</v-btn>
                          <v-btn color="green darken-1" flat @click="addShipBy()">add</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-text-field
                    solo :loading="loading"
                    hide-details
                    v-model="po.payment_amount"
                    label="Shipping Amount"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-textarea
                    label="Note"
                    solo :loading="loading"
                    hide-details
                    v-model.trim="po.note"
                  ></v-textarea>
                </v-flex>
                <v-flex xs6 px-1 py-1>
                  <v-layout row wrap>
                    <v-flex xs12 v-for="(up, u) in po.uploads" :key="'-u-' + u">
                      <v-btn block flat color="secondary" small @click="openLink(up)">DOC #{{u+1}}</v-btn>
                    </v-flex>
                  </v-layout>
                  <input
                    type="file"
                    style="display: none"
                    ref="file"
                    accept="csv/*"
                    @change="onFilePicked"
                  >
                  <v-btn color="primary" block small @click="pickFile()">
                    <v-icon>file_upload</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="text-xs-left">
                <v-flex xs12 py-5>
                  <v-layout row wrap align-center class="text-xs-left align-center elevation-2 pa-2">
                    <v-flex xs12 class="text-xs-center" style="font-size:16px;font-weight:bold;">
                      PO Items
                    </v-flex>
                    <v-flex xs12 v-if="po.v && po.v.currency">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs2 style="font-size:11px;font-weight:bold;">
                          SKU
                        </v-flex>
                        <v-flex xs3 px-1 style="font-size:11px;font-weight:bold;">
                          History
                        </v-flex>
                        <v-flex xs1 style="font-size:11px;font-weight:bold;">
                          Quantity
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:bold;">
                          Price/Unit - {{po.v.currency}}
                        </v-flex>
                        <v-flex xs1 px-1 style="font-size:11px;font-weight:bold;">
                          Total - {{po.v.currency}}
                        </v-flex>
                        <v-flex xs4 px-1 style="font-size:11px;font-weight:bold;">
                          Packing list
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-for="(item, it) in po.items" py-1 :key="'item-'+it">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs2>
                          <span v-if="item.sku && products.filter(x=>x.sku == item.sku).length"
                            style="font-size:11px;"
                            >
                            {{products.filter(x=>x.sku == item.sku)[0].item_name}}
                          </span>
                          <v-autocomplete
                            name="SKU"
                            label="SKU"
                            solo :loading="loading"
                            :items="products"
                            item-text="sku"
                            hide-details
                            :filter="filterObject"
                            :readonly="lock"
                            :class="`${lock? 'tokenField' : ''}`"
                            :color="`${lock? 'white' : ''}`"
                            :background-color="`${lock? 'primary' : ''}`"
                            v-model.trim="item.sku"
                          >
                            <template
                                  slot="item"
                                  slot-scope="{ item }"
                              >
                                <v-list-tile-action>
                                  <v-icon color="primary">amp_stories</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title v-html="item.item_name"></v-list-tile-title>
                                  <v-list-tile-sub-title v-html="item.name_ar"></v-list-tile-sub-title>
                                  <v-list-tile-sub-title v-html="item.sku"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-avatar v-if="item.img">
                                  <img :src="item.img">
                                </v-list-tile-avatar>
                              </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs3 px-1 class="noPOPrint">
                          <v-layout row wrap v-if="getH(item.sku) && getH(item.sku).highest && getH(item.sku).highest.vendor" class="elevation-1 pa-2">
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).highest">
                              {{ getH(item.sku).highest.vendor }}
                            </v-flex>
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).highest">
                              {{ getH(item.sku).highest.price }} Highest
                            </v-flex>
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).lowest">
                              {{ getH(item.sku).lowest.vendor }}
                            </v-flex>
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).lowest">
                              {{ getH(item.sku).lowest.price }} Lowest
                            </v-flex>
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).current">
                              {{ getH(item.sku).current.vendor }}
                            </v-flex>
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).current">
                              {{ getH(item.sku).current.price }} Lowest V
                            </v-flex>
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).latest">
                              {{ getH(item.sku).latest.vendor }}
                            </v-flex>
                            <v-flex xs6 style="font-size:11px;" v-if="getH(item.sku).latest">
                              {{ getH(item.sku).latest.price }} Latest V
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1>
                          <v-text-field
                            name="Quantity"
                            label="Quantity"
                            solo :loading="loading"
                            :readonly="lock"
                            :class="`${lock? 'tokenField' : ''}`"
                            :color="`${lock? 'white' : ''}`"
                            :background-color="`${lock? 'primary' : ''}`"
                            @keypress="isNumber($event)"
                            hide-details
                            v-model.trim="item.quantity"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1 class="noPOPrint">
                          <v-text-field
                            name="Price"
                            label="Price"
                            solo :loading="loading"
                            :readonly="lock"
                            :class="`${lock? 'tokenField' : ''}`"
                            :color="`${lock? 'white' : ''}`"
                            :background-color="`${lock? 'primary' : ''}`"
                            @keypress="isNumber($event)"
                            hide-details
                            v-model.trim="item.price"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1 class="noPOPrint">
                          {{ parseFloat((parseFloat(item.price) * parseFloat(item.quantity)).toFixed(2)) }}
                        </v-flex>
                        <v-flex xs1 px-1 class="noPOPrint">
                          <v-text-field
                            label="$/U"
                            solo :loading="loading"
                            :readonly="lock"
                            :class="`${lock? 'tokenField' : ''}`"
                            :color="`${lock? 'white' : ''}`"
                            :background-color="`${lock? 'primary' : ''}`"
                            hide-details
                            v-model.trim="item.sold_price_dollar_per_unit"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1 class="noPOPrint">
                          <v-text-field
                            label="# in C"
                            solo :loading="loading"
                            :readonly="lock"
                            :class="`${lock? 'tokenField' : ''}`"
                            :color="`${lock? 'white' : ''}`"
                            :background-color="`${lock? 'primary' : ''}`"
                            hide-details
                            v-model.trim="item.in_c"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1 class="noPOPrint">
                          <v-text-field
                            label="C#"
                            solo :loading="loading"
                            :readonly="lock"
                            :class="`${lock? 'tokenField' : ''}`"
                            :color="`${lock? 'white' : ''}`"
                            :background-color="`${lock? 'primary' : ''}`"
                            hide-details
                            v-model.trim="item.c_num"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1 class="noPOPrint">
                          <v-btn color="error" flat block :disabled="lock"
                            @click="()=>{
                              po.items.splice(it, 1)
                            }"
                            small>
                            <v-icon small>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="text-xs-right noPOPrint" style="font-size:18px;font-weight:bold;" v-if="po.v && po.v.currency">
                      {{getTotal()}} {{po.v.currency}}
                    </v-flex>
                    <v-flex xs12 class="noPOPrint">
                      <v-btn color="primary" :disabled="lock" @click="()=>{
                          po.items.push({
                            sku:'',
                            price:'',
                            quantity:''
                          })
                        }">add item</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="text-xs-left" v-if="po.status == 'Partially Received'">
                <v-flex xs12>
                  <v-layout row wrap align-center class="text-xs-left align-center elevation-2 pa-2">
                    <v-flex xs12 class="text-xs-center" style="font-size:16px;font-weight:bold;">
                      Received Items
                    </v-flex>
                    <v-flex xs12 v-if="po.v && po.v.currency">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs6 style="font-size:11px;font-weight:bold;">
                          SKU
                        </v-flex>
                        <v-flex xs5 style="font-size:11px;font-weight:bold;">
                          Quantity
                        </v-flex>
                        
                        <v-flex xs1 px-1>
                          
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-for="(item, it) in po.rec_items" py-1 :key="'item-'+it">
                      <v-layout row wrap class="text-xs-left" align-center>
                        <v-flex xs6>
                          <v-autocomplete
                            name="SKU"
                            label="SKU"
                            solo :loading="loading"
                            :readonly="completeLock"
                            :class="`${completeLock? 'tokenField' : ''}`"
                            :color="`${completeLock? 'white' : ''}`"
                            :background-color="`${completeLock? 'primary' : ''}`"
                            :items="products"
                            item-text="sku"
                            hide-details
                            v-model.trim="item.sku"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs5 px-1>
                          <v-text-field
                            name="Quantity"
                            label="Quantity"
                            solo :loading="loading"
                            :readonly="completeLock"
                            :class="`${completeLock? 'tokenField' : ''}`"
                            :color="`${completeLock? 'white' : ''}`"
                            :background-color="`${completeLock? 'primary' : ''}`"
                            @keypress="isNumber($event)"
                            hide-details
                            v-model.trim="item.quantity"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs1 px-1>
                          <v-btn color="error" flat icon  :disabled="completeLock"
                            @click="()=>{
                              po.rec_items.splice(it, 1)
                            }"
                            small>
                            <v-icon small>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="primary" :disabled="completeLock" @click="()=>{
                          po.rec_items.push({
                            sku:'',
                            price:'',
                            quantity:''
                          })
                        }">add item</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="t4">
              <v-spacer></v-spacer>
              <v-btn color="error" :disabled="completeLock" :loading="loading" v-if="po.key" @click="deletePO()">Delete PO</v-btn>
              <v-btn color="success" :disabled="completeLock" :loading="loading" v-if="!po.key" @click="savePO()">Save PO</v-btn>
              <v-btn color="success" :disabled="completeLock" :loading="loading" v-if="po.key" @click="updatePO()">Update PO</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 class="POprint" PURCHASEPRINT>
          <v-layout row wrap class="text-xs-left white">
            <v-flex xs4 px-1 py-1>
            </v-flex>
            <v-flex xs4 px-1 py-1>
              <canvas id="barcode"></canvas>
            </v-flex>
            <v-flex xs4 px-1 py-1>
            </v-flex>
            <v-flex xs12 py-5>
              <v-layout row wrap align-center class="text-xs-left align-center pa-2">
                <v-flex xs12 class="text-xs-center" style="font-size:16px;font-weight:bold;">
                  PO Received Items
                </v-flex>
                <v-flex xs12 v-if="po.v && po.v.currency">
                  <v-layout row wrap class="text-xs-left" align-center>
                    <v-flex xs6 style="font-size:11px;font-weight:bold;">
                      SKU
                    </v-flex>
                    
                    <v-flex xs6 style="font-size:11px;font-weight:bold;">
                      Quantity
                    </v-flex>
                    
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-for="(item, it) in po.items" py-1 :key="'item-'+it">
                  <v-layout row wrap class="text-xs-left" align-center>
                    <v-flex xs6 px-1>
                      <v-autocomplete
                        name="SKU"
                        label="SKU"
                        :loading="loading"
                        :items="products"
                        item-text="sku"
                        hide-details
                        :readonly="lock"
                        v-model.trim="item.sku"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 px-1>
                      <v-text-field
                        name="Quantity"
                        label="Quantity"
                        :loading="loading"
                        :readonly="lock"
                        @keypress="isNumber($event)"
                        hide-details
                        v-model.trim="item.quantity"
                      ></v-text-field>
                    </v-flex>
                    
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Failed SKU Transaction</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  {{errors}}
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="dialog = false">Dismiss</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, store, storageRef} from '@/fb'
import JsBarcode from 'jsbarcode'
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import axios from 'axios';
import { crmApiUrl } from '@/config/urls';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data() {
    return {
      loading:false,
      dialog:false,
      addinvoicedialog:false,
      new_invoice_by:null,
      users:[],
      t3:false,
      t4:true,
      t5:false,
      t6:false,
      t7:false,
      po:{items:[], rec_items:[], uploads:[]},
      selectedUser:{},
      vendor:{},
      vendors:[],
      currencies:[],
      countries:[],
      warehouses:[],
      selectedVendor:null,
      cDate:null,
      eDate:null,
      iDate:null,
      products:[],
      history:[],
      filter_history:[],
      curr:{},
      pricing:{},
      mv:{items:[]},
      hurt:{items:[]},
      errors:[],
      invoicers:[],
      upload:null,
      imgURL:null,
      file:null,
      imgURLExt:null,
      name:null,
      fileName:null,
      uploadURL:null,
      shippers:[],
      addshipdialog:null,
      new_ship_by:null,
    }
  },
  props:{
    userName:{}
  },
  methods:{
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    openLink(up) {
      window.open(up, '_blank').blur();
      window.focus()
    },
    pickFile() {
      this.$refs.file.click()
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.po.uploads.push(downloadURL)
          this.imgURL = downloadURL
          this.loading = false
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          console.log(this.file)
          this.imgURLExt = `.${this.file.name.split('.').pop()}`
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.fileName = null
        this.uploadURL = null
      }
    },
    goTo(path) {
      this.$router.push(path)
    },
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getTotal() {
      if(this.po.items) {
        let it = this.po.items
        let total = 0
        for (let i = 0; i < it.length; i++) {
          const t = it[i];
          total += parseFloat(t.quantity) * parseFloat(t.price)
        }
        return parseFloat((total).toFixed(2))
      }
    },
    async LoadInvoices(){
      let a = await db.ref('settings/invoiceby').once('value').then(x=>x.val())
      if(a) {
        let b = Object.values(a).map(x=>x.name)
        this.invoicers = b
      }
    },
    async addInvoiceBy() {
      this.loading = true
      await db.ref('settings/invoiceby').push({name:this.new_invoice_by})
      this.new_invoice_by = null
      this.addinvoicedialog = false
      this.loading = false
      this.LoadInvoices()
    },
    async LoadShippers(){
      let a = await db.ref('settings/shipby').once('value').then(x=>x.val())
      if(a) {
        let b = Object.values(a).map(x=>x.name)
        this.shippers = b
      }
    },
    async addShipBy() {
      this.loading = true
      await db.ref('settings/shipby').push({name:this.new_ship_by})
      this.new_ship_by = null
      this.addshipdialog = false
      this.loading = false
      this.LoadShippers()
    },
    async genToken() {
      this.loading = true
      let c = await db.ref('settings/purchaseorders').once('value').then(x=>x.val())
      let vtoken = `ASHYAAT_PO_${randomString(4, 'aA#')}_${c}`
      console.log(vtoken)
      this.po.barcode = 'PO.' + c
      this.po.number = vtoken
      this.loading = false
      return vtoken
    },
    async getWarehouses(){
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>y.data()))
      this.loading = false
    },
    async getCurrencies(){
      return new Promise(async (res, rej)=>{
        let a = await db.ref('settings/app/currencies').once('value').then(x=>x.val())
        console.log(a)
        if(a) {
          let b = Object.keys(a)
          this.curr = a
          this.currencies = Object.values(a).map((x, i)=>{
            return {
              currency:b[i],
              usd:x
            }
          })
          res(true)
        } else {res(true)}
      })
    },
    async getCountries() {
      let a = await db.ref('settings/countrieslite').once('value').then(x=>x.val())
      if(a){
        this.countries = Object.values(a);
        // let lite = []
        // for (let i = 0; i < this.countries.length; i++) {
        //   const c = this.countries[i];
        //   console.log(c)
        //   let kk = Object.keys(c).filter(x=> typeof c[x] != 'object' || x == 'callingCodes')
        //   let d = {}
        //   kk.forEach(x=>d[x]=c[x])
        //   lite.push(d)
        // }
        // await db.ref('settings').update({countrieslite:lite})
        // import currencies 
        // (async x=>{
        //   for (let i = 0; i < this.countries.length; i++) {
        //     const c = this.countries[i];
        //     console.log(c);
        //     if(c.currencies && c.currencies.length) {
        //       let cc = c.currencies[0].code
        //       console.log(cc);
        //       if(cc && cc != '(none)' && c.usd) {
        //         await db.ref('settings/app/currencies').update({
        //           [cc]:c.usd
        //         })
        //       }
        //     }
        //   }
        // })()
      }
    },
    async getPriceHistory(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await db.ref('pricehistory').once('value').then(x=>x.val())
        if(a) {
          let b = Object.keys(a)
          this.history = Object.values(a).map((x, i)=>{
            return {
              ...x,
              key:b[i],
            }
          })
          console.log(this.history)
        }
        this.loading = false
        res(true)
      })
    },
    async updateVendors(){
      this.loading = true
      if(!this.vendor.country
        || !this.vendor.name 
        || !this.vendor.currency
        || !this.vendor.address 
        || !this.vendor.phone
        ) {
        this.loading = false
        return true
      }
      await db.ref(`settings/vendors/${this.vendor.key}`).update(this.vendor)
      this.loadVendors()
      this.loading = false
    },
    async newVendors(){
      this.loading = true
      if(this.vendor.key) {
        this.loading = false
        return true
      }
      if(!this.vendor.country
        || !this.vendor.name 
        || !this.vendor.currency
        || !this.vendor.address 
        || !this.vendor.phone
        ) {
        this.loading = false
        return true
      }
      await db.ref('settings/vendors').push(this.vendor)
      await this.updateVendors()
      this.loadVendors()
      this.loading = false
    },
    async loadVendors(){
      this.loading = true
      let a = await db.ref('settings/vendors').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.vendors = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
      }
      this.vendor = {}
      this.loading = false
    },
    setVendor() {
      this.po.vendor = this.po.v.key
    },
    async loadProducts(){
      this.loading = true
      let a = await db.ref(`productsCoreLite`)
			.once('value').then(x=>x.val())
      let b = Object.keys(a)
      let c = Object.values(a).map((x,i)=>{
        return {
          ...x, 
          key:b[i],
        }})
      this.products = c
      this.loading = false
    },
    checkItemsPO(items){
      let v = true
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if(!item.sku || !item.quantity || !parseInt(item.quantity) || !item.price) {
          v = false
          this.$emit('snackbarNotification', `Item Detail Missing`, 'error')

        }
      }
      let itemsCheck = items.map(x=>x.sku)
      var counts = {};
      for (var i = 0; i < itemsCheck.length; i++) {
        var num = itemsCheck[i];
        counts[num] = counts[num] ? counts[num] + 1 : 1;
      }
      let sCounts = Object.values(counts)
      let mscounts = sCounts.filter(x=> x>1)
      if(mscounts.length) {
        v = false
        this.$emit('snackbarNotification', `Duplicate SKU`, 'error')
      }
      return v
    },
    checkStatus(status, timeline) {
      if(status.includes('Received')) {
        if(timeline) {
          return true
        } else {
          this.$emit('snackbarNotification', `Receive as first transaction`, 'error')
          return false
        }
      } else {
        return true
      }
    },
    async savePO(){
      this.loading = true
      if(
        !this.po.number
        || !this.po.wh
        || !this.po.v
        || !this.po.vendor
        || !this.po.status
        || !this.checkItems(this.po.items)
        || !this.checkStatus(this.po.status, this.po.status_timeline)
      ) {
        this.loading = false
        return true
      }
      let bb = await db.ref('uKeys').push()
      if(!this.po.status_timeline) this.po.status_timeline = {}
      this.po.status_timeline[bb.key] = {
        status:this.po.status,
        agent:this.$props.userName,
        timestamp:new Date(getCDate()).getTime(),
        date:getCDate()
      }
      await db.ref('uKeys').update({
        [bb.key]:null
      })
      this.po.creator = this.$props.userName
      this.po.timestamp = new Date().getTime()
      await store.collection('purchaseOrders').add(this.po)
      console.log(this.po);
      let currRate = this.curr[this.po.v.currency]
      console.log(this.curr)
      console.log(this.po.v.currency)
      console.log(currRate)
      let h = this.history;
      (async x=>{
        for (let i = 0; i < this.po.items.length; i++) {
          const item = this.po.items[i];
          let f = h.filter(x=>x.sku == item.sku)
          if(f.length) {
            let a = f[0]
            await db.ref(`pricehistory/${a.key}/history`).push({
              price: parseFloat((parseFloat(item.price) / parseFloat(currRate)).toFixed(2)),
              country: this.po.v.country,
              vendor: this.po.v.name,
              date: new Date().getTime()
            })
          } else {
            let a = await db.ref('pricehistory').push({
              sku: item.sku,
            })
            await db.ref(`pricehistory/${a.key}/history`).push({
              price: parseFloat((parseFloat(item.price) / parseFloat(currRate)).toFixed(2)),
              country: this.po.v.country,
              vendor: this.po.v.name,
            })
          }
        }
        await db.ref(`settings/purchaseorders`).transaction(function (current_value) {
          return (current_value || 0) + 1;
        });
        await this.addTransaction()
        this.po = {items:[], rec_items:[]}
        this.loading = false
        this.goTo('/purchase-orders')
        // this.genToken()
        // this.getPriceHistory()

      })()
      
    },
    async updatePO(){
      this.loading = true
      if(
        !this.po.number
        || !this.po.wh
        || !this.po.v
        || !this.po.vendor
        || !this.po.status
        || !this.checkItemsPO(this.po.items)
      ) {
        this.loading = false
        return true
      }
      let bb = await db.ref('uKeys').push()
      if(!this.po.status_timeline) this.po.status_timeline = {}
      this.po.status_timeline[bb.key] = {
        status:this.po.status,
        agent:this.$props.userName,
        timestamp:new Date(getCDate()).getTime(),
        date:getCDate()
      }
      await db.ref('uKeys').update({
        [bb.key]:null
      })
      await store.collection('purchaseOrders').doc(this.po.key).update(this.po)
      await axios.get(crmApiUrl(`purchase-orders-sync?key=${this.po.key}`)).then(x=>x.data)
      console.log(this.po);
      let currRate = this.curr[this.po.v.currency]
      console.log(this.curr)
      console.log(this.po.v.currency)
      console.log(currRate)
      let h = this.history;
      (async x=>{
        for (let i = 0; i < this.po.items.length; i++) {
          const item = this.po.items[i];
          let f = h.filter(x=>x.sku == item.sku)
          if(f.length) {
            let a = f[0]
            await db.ref(`pricehistory/${a.key}/history`).push({
              price: parseFloat((parseFloat(item.price) / parseFloat(currRate)).toFixed(2)),
              country: this.po.v.country,
              vendor: this.po.v.name,
            })
          } else {
            let a = await db.ref('pricehistory').push({
              sku: item.sku,
            })
            await db.ref(`pricehistory/${a.key}/history`).push({
              price: parseFloat((parseFloat(item.price) / parseFloat(currRate)).toFixed(2)),
              country: this.po.v.country,
              vendor: this.po.v.name,
            })
          }
        }
        await this.addTransaction()
        this.po = {items:[], rec_items:[]}
        this.loading = false
        this.goTo('/purchase-orders')
        // this.genToken()
        // this.getPriceHistory()
      })()
      
    },
    async loadPO(key){
      let a = await store.collection('purchaseOrders').doc(key).get().then(x=>x.data())
      a.key = key
      let bc = a.barcode ? a.barcode : a.key
      JsBarcode("#barcode", bc, {
        width:1,
      });
      console.log(a)
      if(!a.uploads) {
        a.uploads = []
      }
      this.po = a
    },
    getH(sku){
      let f = this.filter_history.filter(x=>x.sku == sku)
      if(f.length) {
        return f[0]
      } else {
        return false
      }
    },
    setItems() {
      const po = [...this.po.items]
      if(this.po.status == 'Received' || this.po.status == 'Partially Received') {
        const p = po
        this.po.rec_items = po.map(x=>{return{...x}})
      }
    },
    checkTransaction(){
      let st = ['Received', 'Partially Received'];
      return st.includes(this.po.status) && !this.po.transaction
    },
    async addTransaction(){
      return new Promise(async (res, rej)=>{
        if(this.checkTransaction()){
          let items = this.po.rec_items
          let wh = this.po.wh
          let p = this.products
          let status = this.po.status.toLowerCase().split(' ').join('_')
          let user = this.$props.userName
          let date = getCDate()
          this.po.display_items = []
          let po = this.po
          let d = {
            items, wh, status, user, date, po
          }
          console.log(d)
          let t = await axios.post(`${apiBase}/POTransaction`, d, {headers}).then(x=>x.data)
          this.errors = t.failed
          this.dialog = true
          console.log(t)
          res(true)
        } else {
          res(true)
        }
      })
    },
    async savePricing() {
      this.loading = true
      let data = {}
      data.vendor = this.pricing.v.name
      data.country = this.pricing.v.country
      let currRate = this.curr[this.po.v.currency]
      data.price = parseFloat((parseFloat(this.pricing.price) / parseFloat(currRate)).toFixed(2))
      console.log(this.pricing)
      let h = this.history;
      let f = h.filter(x=>x.sku == this.pricing.sku)
      if(f.length) {
        let a = f[0]
        await db.ref(`pricehistory/${a.key}/history`).push(data)
      } else {
        let a = await db.ref('pricehistory').push({
          sku: this.pricing.sku,
        })
        await db.ref(`pricehistory/${a.key}/history`).push(data)
      }
      this.pricing = {}
      this.loading = false
    },
    async importCSVPO(){
      
      let a = [
          
          {"sku":"A.001150","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001121","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001079","price":30,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000195","price":4,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001188","price":5,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001155","price":40,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001182","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000909","price":48,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001134","price":60,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001189","price":60,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000521.M","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000521.L","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000521.XL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000521.XXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.M","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.L","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.XXL","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000906","price":17,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000356","price":12,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001171.R","price":50,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001171.B","price":50,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000887","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001181","price":24,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001156","price":28,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001179","price":35,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001175","price":27,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001190","price":4,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000458","price":45,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001191","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001180","price":5,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001192","price":6,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001002","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000383","price":26,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000046","price":30,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000224","price":7,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.S","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.M","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.L","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XXL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.L","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.XL","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.XXL","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.XXXL","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000390","price":18,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001086","price":190,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001209","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001191","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001210","price":13,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001211","price":4,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001131","price":55,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000906.W","price":17,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001128","price":38,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.L","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000356","price":12,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000182","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000520.L","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000520.M","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.L","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.M","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.S","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.XXL","price":16,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000884","price":22,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000123","price":35.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000884","price":24,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000383","price":26,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001172","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001178","price":70,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001178","price":70,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001152","price":30,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001188","price":5,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001079","price":30,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000886","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001176","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001152","price":30,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000383","price":26,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000356","price":12,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000182","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.L","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.L","price":12.75,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000971","price":13,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000046","price":24,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000390","price":18,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001149","price":15,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000383","price":26,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.FS","price":12.25,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XXL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001175","price":27,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001271","price":22,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001241","price":19.5,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000154","price":12.5,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000174","price":7,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000036","price":18,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000390","price":18,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001129","price":33,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000981","price":13,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000906.W","price":21.5,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000906.W","price":17,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001209","price":10,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001173","price":198,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001131","price":55,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001086","price":193,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001083","price":150,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000244","price":60,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000981","price":13,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001265","price":35,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001178","price":70,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.M","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XXL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000182","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.M","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.L","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.M","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.L","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.XXL","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000543.FS","price":12.25,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000356","price":12,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000393","price":4,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000520.M","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000520.L","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000520.XXL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001150","price":7,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001106","price":340,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000123","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001134","price":60,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.M","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XXL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.M","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.L","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.M","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.L","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.XXL","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000390","price":18,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000195","price":4,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000228","price":13,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001243","price":22,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000046","price":24,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.L","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.XXL","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000182","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.M","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.L","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000532.XXL","price":11,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000971","price":13,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000884","price":22,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.001178","price":70,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.M","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.L","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000967.XXL","price":20,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000524.M","price":8,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"},
          {"sku":"A.000390","price":18,"country":"United Arab Emirates","vendor":"Ali","currancy":"AED"}
      ];
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const it = a[i];
          console.log(it)
          let hh = await db.ref('pricehistory').once('value').then(x=>x.val())
          let b = hh ? Object.keys(hh) : []
          let h = hh ? Object.values(hh).map((x, i)=>{
            return {
              ...x,
              key:b[i],
            }
          }) : []
          let currRate = this.curr[it.currancy]
          let f = h.filter(x=>x.sku == it.sku)
          if(f.length) {
            let a = f[0]
            await db.ref(`pricehistory/${a.key}/history`).push({
              price: parseFloat((parseFloat(it.price) / parseFloat(currRate)).toFixed(2)),
              country: it.country,
              vendor: it.vendor,
            })
          } else {
            let a = await db.ref('pricehistory').push({
              sku: it.sku,
            })
            await db.ref(`pricehistory/${a.key}/history`).push({
              price: parseFloat((parseFloat(it.price) / parseFloat(currRate)).toFixed(2)),
              country: it.country,
              vendor: it.vendor,
            })
          }
        }
      })()
    },
    async deletePO(){
      await store.collection('purchaseOrders').doc(this.po.key).delete()
      this.goTo('/purchase-orders')
    },
    checkItems(items){
      let a = true
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if(!item || !item.sku || !item.quantity) {
          a = false
        }
      }
      return a
    },
    async mvOrderOut() {
      this.loading = true
      if(this.checkItems(this.mv.items)) {
        this.mv.date = getCDate()
        this.mv.user = this.$props.userName
        let m = await store.collection('moveorders').add(this.mv).then(x=>x)
        this.mv.key = m.id
        console.log(this.mv)
        let a = await axios.post(`${apiBase}/MVTransactionOut`, this.mv, {headers}).then(x=>x.data)
        console.log(a)
        this.loading = false
        this.mv = {items:[]}
      } else {
        this.loading = false
        this.$emit('snackbarNotification', `ITEM SKU OR QTY MISSING`, 'Error')
      }

    },
    async hurtOrder() {
      this.loading = true
      if(this.checkItems(this.hurt.items)) {
        this.hurt.user = this.$props.userName
        this.hurt.date = getCDate()
        let m = await store.collection('hurtorders').add(this.hurt).then(x=>x)
        this.hurt.key = m.id
        console.log(this.hurt)
        let a = await axios.post(`${apiBase}/HurtTransaction`, this.hurt, {headers}).then(x=>x.data)
        console.log(a)
        this.loading = false
        this.hurt = {items:[]}
      } else {
        this.loading = false
        this.$emit('snackbarNotification', `ITEM SKU OR QTY MISSING`, 'Error')
      }

    },
    async unhurtOrder() {
      this.loading = true
      let m = await store.collection('hurtorders').add(this.hurt).then(x=>x)
      this.hurt.key = m.id
      this.hurt.user = this.$props.userName
      this.hurt.date = getCDate()
      console.log(this.hurt)
      let a = await axios.post(`${apiBase}/UNHurtTransaction`, this.hurt, {headers}).then(x=>x.data)
      console.log(a)
      this.loading = false
      this.hurt = {items:[]}

    },
  },
  watch:{
    "po.v"(){
      if(this.po.v && this.po.v.country) {
        this.filter_history = this.history.map((x, i)=>{
          let currRate = this.curr[this.po.v.currency]
          console.log(this.curr);
          console.log(this.po.v.currency);
          console.log(currRate);
          let h = x.history ? x.history : {}
          let f = Object.values(h).filter(x=>x.country == this.po.v.country).map(x=>{
            return {
              ...x,
              price: parseFloat((parseFloat(x.price)*parseFloat(currRate)).toFixed(2))
            }
          })
          let sort = f.sort((a, b)=> parseFloat(a.price) - parseFloat(b.price))
          let sort2 = f.filter(x=>x.vendor == this.po.v.name).sort((a, b)=> parseFloat(a.price) - parseFloat(b.price))
          return {
            ...x,
            lowest:sort[0],
            highest:sort[sort.length-1],
            current:sort2[0],
            latest:f[f.length-1]
          }
        })
        console.log(this.filter_history)
      }
    }
  },
  computed:{
    lock(){
      return this.po && this.po.status && this.po.status != 'Pending' && this.po.status != 'Purchase'
    },
    completeLock() {
      return this.po && this.po.status && this.po.status_timeline
      && Object.values(this.po.status_timeline)[Object.values(this.po.status_timeline).length-1].status.includes('Received')
    }
  },
  async created(){
    await this.getCurrencies()
    this.LoadInvoices()
    this.LoadShippers()
    await this.getPriceHistory()
    this.getCountries()
    this.getWarehouses()
    this.loadVendors()
    this.loadProducts()
    let p = this.$route.params
    if(p && p.id) {
      let key = p.id
      this.loadPO(key)
    } else {
      this.genToken()
    }
 
    
    //this.importCSVPO()
  }
}
</script>

<style>
@media print {
  .noPOPrint{
    display:none;
  }
  .POprint {
    display:flex !important;
  }
}
.POprint {
  display:none;

}
</style>
